import Dialog from "../../classes/Dialog.js";
import TokenStore from "../../classes/TokenStore.js";
import BluffsGroups from "../../classes/BluffsGroups.js";
import { gameObserver, mainStore } from "../../constants/observers.js";
import { lookupOne } from "../../utils/elements.js";
import { parseGrimoireImport, placeImportedGrimoire } from "../../utils/grimoire-import.js";

const button = lookupOne("#import-grimoire");
const dialog = Dialog.create(lookupOne("#grimoire-import"));
const input = lookupOne("#grimoire-import-data");
const error = lookupOne("#grimoire-import-error");
let pending = false;

const importText = async (text) => {
    const tokenStore = await TokenStore.get();
    const data = parseGrimoireImport(text, tokenStore);
    const current = mainStore.get();
    if (current.log.startedAt && !current.log.endedAt) {
        throw new Error("Сначала завершите текущую игру.");
    }
    if ((current.tokens.length || current.log.entries.length
        || current.bluffs.groups?.some((group) => group.set.some(Boolean)))
        && !window.confirm("Заменить жетоны, напоминания и блефы? Игровой лог и кадры предыдущей игры будут очищены.")) {
        return;
    }
    lookupOne("#grimoire").open = true;
    gameObserver.trigger("clear");
    const pad = lookupOne(".js--pad").pad;
    placeImportedGrimoire(data, pad, tokenStore, (reminder) => tokenStore.createImportedReminder(reminder));
    mainStore.setData("importedRoles", data.roles);
    gameObserver.trigger("imported-roles", {
        characters: data.roles.map((id) => tokenStore.getCharacter(id))
    });
    BluffsGroups.get().ready({ index: 0, groups: [{ set: data.bluffs }] });
    input.value = "";
    dialog.hide();
};

button.addEventListener("click", async () => {
    if (pending) {
        return;
    }
    pending = true;
    button.disabled = true;
    error.textContent = "";
    try {
        let text;
        try {
            text = await navigator.clipboard.readText();
        } catch {
            dialog.show();
            input.focus();
            return;
        }
        await importText(text);
    } catch (exception) {
        error.textContent = exception.message;
        dialog.show();
        input.focus();
    } finally {
        pending = false;
        button.disabled = false;
    }
});

lookupOne("#grimoire-import-form").addEventListener("submit", async (event) => {
    event.preventDefault();
    if (pending) {
        return;
    }
    pending = true;
    const submit = event.submitter;
    submit.disabled = true;
    error.textContent = "";
    try {
        await importText(input.value);
    } catch (exception) {
        error.textContent = exception.message;
    } finally {
        pending = false;
        submit.disabled = false;
    }
});
